/* eslint-disable max-len */
import React from 'react'
import AnimatedList from '../../../../../../../components/Animation/AnimatedList'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { convertEpochToDateFormat } from '../../../../../../../CommonMethods/convertEpochToDateFormat'
const TableBody=({tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg})=>{
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{convertEpochToDateFormat(tableData?.timestamp,dateformat)}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td id= "patient_name1" className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{[tableData?.patient_first_name, tableData?.patient_middle_name, tableData?.patient_last_name].filter(Boolean).join(' ')}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.age === '' || tableData?.age === undefined || tableData?.age === null) ? '-' : tableData?.age}</td>
                        <td className="px-[18px] py-2 text-sm text-staart font-normal text-[#031624]">{tableData?.alert_title===undefined || tableData?.alert_title==="" ? "-" : tableData?.alert_title}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_priority===""||tableData?.alert_priority===undefined?"-":tableData?.alert_priority}</td>
                        <td className="px-[18px] py-2 text-sm text-justify font-normal text-[#031624]">{tableData?.alert_message === "" || tableData?.alert_message === undefined
                            ? "-"
                            : tableData?.alert_message.length > 87
                                ? `${tableData.alert_message.slice(0, 87)}...`
                                : tableData.alert_message}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.sender_user_id===""||tableData?.sender_user_id===undefined?"-":tableData?.sender_user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{[tableData?.sender_first_name, tableData?.sender_last_name].filter(Boolean).join(' ')}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.acknowledged_at===""||tableData?.acknowledged_at===undefined?"-": convertEpochToDateFormat(tableData?.acknowledged_at,dateformat)}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.acknowledged_by==="" || tableData?.acknowledged_by===undefined ?"-":tableData?.acknowledged_by}
                        </td>
                        <td id='userName' className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.acknowledged_first_name || tableData?.acknowledged_last_name)
                                ? [tableData?.acknowledged_first_name, tableData?.acknowledged_last_name].filter(Boolean).join(' ')
                                : "-"
                            }
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.organization_id===undefined || tableData?.organization_id ==="" ? "-" : tableData?.organization_id}</td>
                        <td id='orgName' className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px]">{tableData?.organization_name===undefined || tableData?.organization_name ==="" ? "-" : tableData?.organization_name}</td>
                        
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody